import { inject, Injectable, Injector, signal } from '@angular/core';
import config from '@config';
import { UserService } from '@services/user.service';
import { Tenant } from '@shared/models/tenant.model';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private injector = inject(Injector);
  private _userService?: UserService;

  allTenants = signal<Tenant[]>(Object.values(config.tenants)).asReadonly();

  get userService(): UserService {
    return (this._userService ??= this.injector.get(UserService));
  }

  getTenantById(tenantId: string): Tenant | undefined {
    return this.allTenants().find(tenant => tenant.id === tenantId);
  }

  getDefaultTenant(): Tenant | null {
    return this.userService.getUserAccessibleTenants()[0] ?? null;
  }
}
